import React from 'react'
import './App.css'
import Pages from './components/Pages/Pages'
const App = () => {
  return (
    <>
      <Pages/>
    </>
  )
}

export default App